export const environment = {
  production: false,
  baseUrl:'/api/v1'
};
